import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd/es/grid';
import CarouselWithIndicators from '../../../Utils/CarouselWithIndicators';
import { useBreakpoint } from '../../../Utils/Responsive';
import { COMPANY_COUNT } from '../../../Constants/Constant';
import { isBeamUser } from '../../../Utils/usersTypes';

export const testimonials = [
  {
    heading: '"Best-in-class technology"',
    user: {
      logo: 'https://storage.googleapis.com/falcon-shared-images-front-end/assets/Michael_Wood_USL.webp',
      isPersonImage: true,
      name: 'Michael Wood',
      position: 'Director of Project Management, US Lawns'
    },
    comment:
      'Our partnership with Attentive aligns perfectly with our long-standing commitment to provide our Franchisees with best-in-class resources, technology, tools and training.'
  },
  {
    heading: '“Measurements are spot on”',
    user: {
      logo: 'https://storage.googleapis.com/falcon-shared-images-front-end/assets/Mark_Michalek_Juniper.webp',
      isPersonImage: true,
      name: 'Mark Michalek',
      position: 'Director of Maintenance Estimating, Juniper'
    },
    comment:
      "Attentive is saving a lot of time for our team. The software is able to measure sites for us quickly and the measurements are spot on. It's made our sales process highly efficient."
  },
  {
    heading: '“Continuous flow of opportunities into the sales funnel”',
    user: {
      logo: 'https://storage.googleapis.com/falcon-shared-images-front-end/assets/Bill_Hope_Beary.webp',
      isPersonImage: true,
      name: 'Bill Hope',
      position: 'Business Development, Beary Landscaping'
    },
    comment:
      'Attentive has been extremely helpful in providing my team and me with expedient & accurate estimates. It has also allowed us to apply a more continuous flow of opportunities into the sales funnel.'
  },
  {
    heading: '“Help us refine our bidding process”',
    user: {
      logo: 'https://storage.googleapis.com/falcon-shared-images-front-end/assets/Daniel_Leuenberger.webp',
      isPersonImage: true,
      name: 'Daniel Leuenberger',
      position: 'General Manager of Landscaping, Denver Commercial Property Services'
    },
    comment:
      'Attentive is very cost-effective & the detailed reports help us refine our bidding process. We don’t have to worry about measurements at all anymore.'
  },
  {
    heading: '“Very strong documented measurements”',
    user: {
      logo: 'https://storage.googleapis.com/falcon-shared-images-front-end/assets/Brian_Steele.webp',
      isPersonImage: true,
      name: 'Brian Steel',
      position: 'Director of Operations, East Coast Facilities'
    },
    comment:
      'I am really confident about the Attentive software & its accuracy. We get very strong documented measurements and the margin of error is extremely low.'
  },
  {
    heading: '“Saved us countless hours”',
    user: {
      logo: 'https://storage.googleapis.com/falcon-shared-images-front-end/assets/Daniel_Ware.webp',
      isPersonImage: true,
      name: 'Daniel Ware',
      position: 'Assistant Branch Manager, Duval Landscape Maintenance'
    },
    comment: 'The software has saved us countless hours of measuring while providing more accurate estimates.'
  },
  {
    heading: '“Very easy to use”',
    user: {
      logo: 'https://storage.googleapis.com/falcon-shared-images-front-end/assets/Christian_Oyer.webp',
      isPersonImage: true,
      name: 'Christian Oyer',
      position: 'Lead Estimator, Crimson Valley'
    },
    comment:
      'It’s very easy to use and saves time in gathering data on the properties. The detailed reports do a great job at breaking down where the measurements came from.'
  },
  {
    heading: '“Reports are detailed”',
    user: {
      logo: 'https://storage.googleapis.com/falcon-shared-images-front-end/assets/Ben_Carruthers.webp',
      isPersonImage: false,
      name: 'Ben Carruthers',
      position: 'President at Carruthers Landscape Management'
    },
    height: 'unset',
    comment:
      'We recently measured 232 properties with Attentive. The software is very smooth and we are impressed with it. The reports are detailed and we really enjoy working with them.'
  },
  {
    heading: '“Great accuracy”',
    user: {
      logo: 'https://storage.googleapis.com/falcon-shared-images-front-end/assets/Distefano_Landscape.webp',
      isPersonImage: false,
      name: 'Don Distefano',
      position: 'President at Distefano Landscape Services Inc'
    },
    height: 'unset',
    comment:
      "With Attentive, I don't have to waste time on measurements at all. The software takes care of the measurements while also maintaining great accuracy."
  }
];
export const testimonials_beam = [
  {
    heading: '"Beam AI is a game-changer for contractors across all trades"',
    user: {
      logo: 'https://cdn.prod.website-files.com/6548a2bd6f5c62243aa1e3c9/67612f40fa9d32065720a0d4_HC%20360x240.png',
      isPersonImage: false,
      name: 'David Smith',
      position: 'Impressions in Concrete Inc.'
    },
    comment: `"Beam AI delivers accurate takeoffs, ensuring no hassle in estimating, which has simplified our bidding process. It's a game-changer for contractors across all trades, and I wouldn’t hesitate to recommend it."`
  },
  {
    heading: '"Beam AI allows me to handle more projects efficiently"',
    user: {
      logo: 'https://storage.googleapis.com/falcon-shared-images-front-end/wally-walls.avif',
      isPersonImage: true,
      name: 'Kelly Chamberlin',
      position: 'Wall Holdings LLC DBA Wally Walls'
    },
    comment: `"I've had a fantastic experience using Beam AI! This tool has significantly cut down the time it takes me to prepare bids, allowing me to handle more projects efficiently. The accuracy of the takeoffs is remarkable, ensuring that my bids are competitive and precise. Additionally, the team at Beam AI is wonderful to work with; they are supportive and always willing to help. I highly recommend Beam AI to anyone looking to streamline their bidding process and improve accuracy."`
  },
  {
    heading: '"They take it to a level of art"',
    user: {
      logo: 'https://cdn.prod.website-files.com/6548a2bd6f5c62243aa1e3c9/67614f40c14fb0ccc0e8d89f_ADG%20logo%20360x240.png',
      isPersonImage: false,
      name: 'Bram Bessoff',
      position: 'ADG Services'
    },
    comment: `"Beam AI has proven to us that their AI is more than capable of handling the most complicated and detailed takeoffs beyond perfection... They take it to a level of art. The Takeoff presentation is so stunning I want to print out large scale reproductions to hang around the office so I can admire their architectural beauty all day long. We are BEAM believers!"`
  },
  {
    heading: `"Beam AI's software enables me to prepare more bids than my competition"`,
    user: {
      logo: 'https://cdn.prod.website-files.com/6548a2bd6f5c62243aa1e3c9/67614f40d075d10fe38a643a_SCC%20logo%20360x240.png',
      isPersonImage: false,
      name: 'Philip Butler',
      position: 'Spalding Concrete Company'
    },
    comment: `"Using Beam AI has significantly improved our estimating process. It has allowed me to keep up with the 3 to 4 invitations I get a day. We can now prepare more bids than my competition. The accuracy it provides has saved us a tremendous amount of time and effort. We have already begun to see our first successful bid with Beam - which we wouldn't have won without it."`
  },
  {
    heading: `"Saves a lot of our time enhancing our productivity"`,
    user: {
      logo: 'https://cdn.prod.website-files.com/6548a2bd6f5c62243aa1e3c9/67614f3f518e635b19599677_Jack%20logo%20360x240.png',
      isPersonImage: false,
      name: 'Asmitha Sathyan',
      position: 'Jack Engineering'
    },
    comment: `"We’ve been using Beam AI’s takeoff software for a few months now, and we’re happy to use it over and over again because it helps share our workload and meet deadlines. The software is reliable in terms of its accuracy and timeframes and saves a lot of our time enhancing our productivity during busier working days. Beam AI is very easy to use and we highly recommend the software!"`
  },
  {
    heading: `"Incredible accuracy and fast support - Beam AI never lets me down"`,
    user: {
      logo: 'https://cdn.prod.website-files.com/6548a2bd6f5c62243aa1e3c9/67614f40dd2bf209e8fe3da3_Omnia%20logo%20360x240.png',
      isPersonImage: false,
      name: 'Steve Conley',
      position: 'Omnia Site Management'
    },
    comment: `"Beam AI's auto-generated takeoffs are incredibly accurate, providing near flawless information every time. I rely on their data to ensure my bids are competitive, and they've never let me down. Their dedication to customer success is unmatched, and I couldn’t recommend them more!"`
  },
  {
    heading: `"Beam AI allows us to win more bids"`,
    user: {
      logo: 'https://cdn.prod.website-files.com/6548a2bd6f5c62243aa1e3c9/67614f40d94765200c7b88bf_Petticoat%20logo%20360x240.png',
      isPersonImage: false,
      name: 'Irana Perez',
      position: 'Estimator, Petticoat-Schmitt Civil Contractors Inc.'
    },
    comment: `"Beam AI's software allows me to focus on what truly matters in the bidding process—strategy and knowing how to win. I've had a fantastic experience using Beam AI. This tool enables me to dedicate more time to reviewing every detail and specification, giving me a competitive advantage over other companies. It makes the bidding process significantly more efficient and eliminates errors, improving the accuracy of each deliverable."`
  },
  {
    heading: `"Saves us countless hours while improving accuracy"`,
    user: {
      logo: 'https://cdn.prod.website-files.com/6548a2bd6f5c62243aa1e3c9/67614f40dd9510471f6db299_Builders%20logo%20360x240.png',
      isPersonImage: false,
      name: 'Josh Tuttle',
      position: 'Senior Project Manager, Builders Stone and Supply'
    },
    comment: `"Beam AI's automated takeoff software streamlines our estimating process, saving us countless hours while improving accuracy. With Beam AI, I'm able to handle more bids than ever before. The support team has been incredibly helpful throughout. Beam AI empowers us to focus on what truly matters - winning more projects and growing our business."`
  },
  {
    heading: `"We’re winning more bids with Beam AI’s support"`,
    user: {
      logo: 'https://cdn.prod.website-files.com/6548a2bd6f5c62243aa1e3c9/67762a1989e7793bdd4b4d4b_10.png',
      isPersonImage: false,
      name: 'Dylan Wiman',
      position: 'Rocky Mountain Steel'
    },
    comment: `"Beam AI has drastically reduced our bidding time, enabling us to take on more bids with fewer estimators. The team’s support has been exceptional, and we’re excited to see where this partnership takes us."`
  },
  {
    heading: '“Helped me win a multi-million $ bid”',
    user: {
      logo: 'https://storage.googleapis.com/falcon-filestore/legacycompaniesinc_logo.png',
      isPersonImage: false,
      name: 'John C Meyer',
      position: 'Project Manager & Business Development Services, Legacy Companies, Inc'
    },
    height: 'unset',
    comment:
      "Beam Al has helped me save at least 90% time on takeoffs. It's highly accurate - it helped me win a multi-million $ bid by a margin of a few thousand dollars. Now I'm able to focus on refining my estimates instead of spending hours on takeoffs. Kudos to Beam Al for the great product!"
  }
];
export const beam_pricing_testimonials = [
  {
    heading: '“Helped me win a multi-million $ bid”',
    user: {
      logo: 'https://storage.googleapis.com/falcon-filestore/legacycompaniesinc_logo.png',
      isPersonImage: false,
      name: 'John C Meyer',
      position: 'Project Manager & Business Development Services, Legacy Companies, Inc'
    },
    height: 'unset',
    comment:
      "Beam Al has helped me save at least 90% time on takeoffs. It's highly accurate - it helped me win a multi-million $ bid by a margin of a few thousand dollars. Now I'm able to focus on refining my estimates instead of spending hours on takeoffs. Kudos to Beam Al for the great product!"
  }
];

const Testimonials = () => {
  const breakpoint = useBreakpoint();
  const [dynamicArray, setDynArray] = useState(testimonials);
  const beamUser = isBeamUser();
  useEffect(() => {
    const myTestimonials = beamUser ? beam_pricing_testimonials : testimonials;
    setDynArray(
      myTestimonials.reduce((acc, val, inx) => {
        // @ts-expect-error TS(2322): Type '{ heading: string; user: { logo: string; isP... Remove this comment to see the full error message
        if (breakpoint === 'sm') acc.push([val]);
        else {
          const desp = inx % (breakpoint === 'md' ? 2 : 3) === 0;
          if (desp) {
            // @ts-expect-error TS(2322): Type '{ heading: string; user: { logo: string; isP... Remove this comment to see the full error message
            acc.push([val]);
          } else {
            // @ts-expect-error TS(2339): Property 'push' does not exist on type 'never'.
            acc[acc.length - 1]?.push(val);
          }
        }
        return acc;
      }, [])
    );
  }, [breakpoint, beamUser]);

  return (
    <div className='testimonial-sec container-fluid'>
      {!isBeamUser() ? (
        <h2 className='font-bold text-center med-heading section-head'>
          Trusted by <span className='text-light-green'> {COMPANY_COUNT} companies </span> across the US and Canada
        </h2>
      ) : null}

      {/* Non-Mobile - Carousel */}
      {breakpoint !== 'sm' && (
        <CarouselWithIndicators dots={false} arrows width='95%'>
          {dynamicArray.map((group, gInx) => (
            <div key={gInx}>
              <Row justify='center' align='middle'>
                {(Array.isArray(group) ? group : [group]).map((testimonial, tInx) => (
                  <Col key={tInx} span={24} md={12} lg={8} className='flex justify-center'>
                    <TestCard testimonial={testimonial} />
                  </Col>
                ))}
              </Row>
            </div>
          ))}
        </CarouselWithIndicators>
      )}

      {/* Mobile - Horizontal Scrollable Cards */}
      {breakpoint === 'sm' && (
        <>
          <div className='scroll-invisible' style={{ overflow: 'auto', display: 'flex' }}>
            {dynamicArray.map((group, gInx) => (
              <div key={gInx}>
                {(Array.isArray(group) ? group : [group]).map((testimonial, tInx) => (
                  <TestCard
                    key={tInx}
                    testimonial={testimonial}
                    cardStyle={dynamicArray?.length === 1 ? 'full-width-card' : ''}
                  />
                ))}
              </div>
            ))}
          </div>

          {dynamicArray?.length > 1 ? (
            <div className='mt-5 ml-auto' style={{ width: '3rem', height: '100%' }}>
              <ArrowIcon />
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export const TestCard = ({ testimonial, cardStyle }: $TSFixMe) => {
  return (
    <div className={`test-card ${cardStyle}`}>
      <h3 className='fw-bold-3'>{testimonial.heading}</h3>
      <div className='text-left '>
        <div className='test-bottom'>
          <div className='test-image'>
            <img src={testimonial.user.logo} alt='' style={{ width: testimonial.width, height: testimonial.height }} />
          </div>
          <div>
            <h6 className='fw-bold-3 fs-3 mb-0'>{testimonial.user.name}</h6>
            <span className='italic'>{testimonial.user.position}</span>
          </div>
        </div>
        <div className='text-height test-comment'>{testimonial.comment}</div>
      </div>
    </div>
  );
};

function ArrowIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 30'>
      <path fill='none' stroke='#fff' strokeWidth='2' d='M0 15h40M30 0l14 15-14 15' />
    </svg>
  );
}

export default Testimonials;
